import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'
import { ModuleGate } from '@/components/module-gate'

export const PIPELINE_VIEWS = ['list', 'board', 'funnel'] as const

const searchSchema = z.object({
  view: z.enum(PIPELINE_VIEWS).optional().default('list'),
  stage: z
    .enum(['pre_quote', 'quoted', 'won', 'lost', 'on_hold', 'expired'])
    .optional(),
  sort_by: z.string().optional().default('updated_at'),
  sort_dir: z.enum(['asc', 'desc']).optional().default('desc'),
})

export const Route = createFileRoute('/_authed/pipeline')({
  validateSearch: searchSchema,
  component: () => (
    <ModuleGate moduleKey="pipeline">
      <Outlet />
    </ModuleGate>
  ),
})
